<template>
<div class="mt-3 py-5">
	<b-container class="px-3 p-md-0">
		<b-row>
			<b-col cols="12" md="8" class="m-auto px-3">

        <div class="container">

					<div class="row justify-content-center pt-2 pb-5">

              <nav class="pankuzu w-100">
                <ul class="my-4">
                  <li><img class="" src="/static/img/icon/pankuzu.png" style="height: 17px;padding-bottom: 3px;"><a @click="jump(0)">  ピアチュウ TOP</a></li>
                  <li>  評価投稿ガイドライン</li>
                </ul>
              </nav>

              <div class="card">
                <div class="card-header text-center">評価投稿ガイドライン</div>
                <div class="card-body">
                  <p>ピアチュウは、中古ピアノを探している方（以下ユーザー）と優良なピアノ販売事業者（以下販売事業者）を結びつけることを目的としています。ユーザーによる販売事業者やピアノへの評価投稿は、他のユーザーにとって有益な情報であり、販売事業者の実績を可視化する貴重な手段でもあります。ユーザーと販売事業者の双方にとって質の高い評価投稿を保つために、以下のガイドラインを制定します。</p>
                  <h2>評価投稿に関するお願い</h2>
                  <p>投稿内容は、ピアチュウを通して購入申し込みをし、実際にピアノの設置までの体験した内容のみとすることをお願いします。 評価の内容は、インターネット上に残るものであり、個人でもあるピアノ技術者（ピアノ調律師）やピアノ販売事業者のブランディングにつながるものでもあります。 ユーザーのみなさまにはガイドライン遵守にご協力をお願いします。</p>
                  <h2>禁止行為</h2>
                  <p>これらの行為を行ったと運営事務局が判断した場合には、事前の通知なしに評価の削除、その他運営事務局が必要と判断する措置を講じることができるものとします。</p>
                  <ul>
                    <li>知的財産権、肖像権、プライバシー（氏名、住所、電話番号などの個人情報を含む）の権利、名誉、その他の権利又は利益を侵害する行為</li>
                    <li>犯罪行為に関連する行為又は公序良俗に反する行為</li>
                    <li>猥褻な内容又は青少年に有害な情報を送信する行為</li>
                    <li>人種、民族、信条、教育、収入などを根拠にする差別的表現行為</li>
                    <li>倫理的に問題がある行為、他人に嫌悪感を与える内容の情報を開示する行為</li>
                    <li>嫌がらせ行為、誹謗中傷行為、その他精神的・経済的被害を与える可能性のある行為</li>
                    <li>事実と異なる内容を記述する行為</li>
                    <li>広告宣伝など、ピアチュウの販売商品に関連のない内容を記載する行為</li>
                    <li>その他、運営事務局が不適切と判断する行為</li>
                  </ul>
                  <h2>評価の内容についての留意点</h2>
                  <p>以下のような投稿を行った場合は、投稿の削除や利用停止となります。サイト運営側より一部修正や削除を行う場合や販売事業者からの修正、削除依頼による場合もあります。投稿は一回のみであり、ガイドラインに反した場合を除いて修正、削除はできません。</p>
                  <ul>
                    <li>根拠がよくわからない
                      <ul>
                        <li>例：　とにかく試弾に行く価値ありません、行っても損します、など。</li>
                      </ul>
                    </li>
                    <li>事実とは違う内容
                      <ul>
                        <li>例：　販売事業者が最初に提示した付属品が付いてこなかったのでまったく信用できない、など。（実際は後で送付されることになっていた。） </ul>
                      </li>
                      <li>極端に主観的で一方的な断定や個人への誹謗中傷と受け取ることができる批判
                        <ul>
                          <li>　例：　二度とこんなひどいところには行きません、試弾の時の対応が最悪でした、この値段は詐欺のレベルです、など。 </ul>
                        </li>
                        <li>サービスと関連のない内容の投稿
                          <ul>
                            <li>例：　こんど、会員さんの○○さん、○○さんらと、いっしょにゴルフでもいきましょう、など。 </ul>
                          </li>
                          <li>販売事業者に対して、一方的な要求や質問を行うこと
                            <ul>
                              <li>例：　納得できないので、返金してください、○○の件について、対応をお願いします、など。 </ul>
                            </li>
                            <li>電話番号、住所などの個人情報の記載</li>
                            <li>販売事業者やピアノ技術者（ピアノ調律師）へのプライバシー無視の記載
                              <ul>
                                <li>例：　最近彼の仕事はうまく行ってなくて、店じまい寸前だ、など。 </ul>
                              </li>
                              <li>言葉を引用したり、事実が不明瞭な発言
                                <ul>
                                  <li>例：　○○ピアノ販売事業者は、「自分のところがいちばん安い」と言っていたが、実際は他にもあった、など。 </ul>
                                </li>
                                <li>販売事業者やその販売ページなどと関係のない記載
                                  <ul>
                                    <li>例：　もしよければ、こちらのサイトも見てくださいね　→　http://○○.con など。 </ul>
                                  </li>
                                  <li>自身の体験以外の内容
                                    <ul>
                                      <li>例：　わたしはお会いできませんでしたが、代表の○○さんは、すばらしい接客を行うと聞いております、など。 </ul>
                                    </li>
                  </ul>
                  <h2>上記ガイドラインに反する投稿についての扱い</h2>
                  <p>ガイドラインに反する投稿があった場合、以下の２つの対応を行う場合があります。予めご了承ください。</p>
                  <ul>
                    <li>サイト運営側にて修正、削除を行う</li>
                    <li>投稿者に対して修正、削除を依頼する</li>
                  </ul>
                  <p>本サイト側がガイドラインに反しないと判断した場合は、修正、削除を行うことはありません。投稿を受けた当事者からの違反の報告は、その報告のみを受け付けており、具体的な修正や削除の依頼は受け付けかねますのでご理解をお願いいたします。</p>
                </div>
              </div>

					</div>

        </div>

			</b-col>
		</b-row>
	</b-container>
</div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'GuidelineReview',
  data() {
    return {
    }
  },
  methods: {
    jump(number) {
      if (number==0) {
        this.$router.push({path: '/'});
      }
    },
  },
	computed: {
	},
  created() {
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/GuidelineReview.vue